import { useTranslation } from "react-i18next";
import { IContentAppealSubmissionInfo } from "../../model/interface";
import { Input, Label } from "@fluentui/react-components";
import { CheckmarkCircle48Filled } from "@fluentui/react-icons";
import './ContentAppealSubmission.scss';

export default function ContentAppealSubmission(props: IContentAppealSubmissionInfo) {
    const { t } = useTranslation();

    return (
        <div>
            <div className="form-overview__submission" role="alert">
                <div><CheckmarkCircle48Filled /></div>
                <h1 className="form-overview__header"> {t('Common.thank-you')}</h1>
                <p className="form-overview__paragraph">
                    {
                        props.isNewSubmission
                            ? t('Appeal.Common.appeal-submitted')
                            : t('Appeal.Common.appeal-already-submitted')
                    }
                </p>
            </div>
            <div className="form-fields">
                <div className="appeal-number-submission">
                    <Label id="appealNumberSubmissionLabel">{t('Appeal.Common.appeal-number')}</Label>
                    <Input
                        id="appealNumberSubmission"
                        aria-labelledby="appealNumberSubmissionLabel"
                        data-testid="appealNumberSubmission"
                        type="text"
                        disabled
                        value={props.appealNumber ? props.appealNumber : t('Appeal.Common.appeal-number')}
                    />
                </div>
                <div className="appeal-date-submission">
                    <Label id="appealDateSubmissionLabel">{t('Appeal.Common.date-of-appeal')}</Label>
                    <Input
                        id="appealDate"
                        aria-labelledby="appealDateSubmissionLabel"
                        data-testid="appealDate"
                        type="text"
                        disabled
                        value={props.appealDate ? props.appealDate : t('Appeal.Common.date-of-appeal')}
                    />
                </div>
                <div className="policy-violation-submission">
                    <Label id="policyViolationSubmissionLabel">{t('Appeal.Common.policy-violated')}</Label>
                    <Input
                        id="policyViolationSubmission"
                        aria-labelledby="policyViolationSubmissionLabel"
                        type="text"
                        disabled
                        value={props.policyViolated ? props.policyViolated : t('Appeal.Common.policy-violated')}
                    />
                </div>
                <div className="submission-sub-text">
                    <span className="submission-sub-text__remarks">{t('Appeal.Common.submission-remarks-one')}</span>
                    <span className="submission-sub-text__remarks">{t('Appeal.Common.submission-remarks-two')}</span>
                </div>
            </div>
        </div>
    );
};
